import React from "react";
import { PageBuilderDescriptionTextFragment } from "types/graphql-types";
import { ResponsiveSlideshow } from "components/Slideshow/Slideshow";
import { graphql } from "gatsby";
import TextBox from "components/TextBox/TextBox";
import PageBuilderButtonCTA from "./PageBuilderButtonCTA";
import {
  ButtonsContainer,
  DescriptionText,
  DescriptionTextColumn,
  DescriptionTextColumnContent,
  DescriptionTextColumnContentLeft,
  DescriptionTextColumnContentRight,
  DescriptionTextColumnLeadIn,
  DescriptionTextContent,
  DescriptionTextLeadIn
} from "@silversea-ssc/ui-components-react";
import { isPresent } from "src/utils/checks";

const PageBuilderDescriptionText: React.FC<PageBuilderDescriptionTextFragment> = ({
  content,
  slideshow,
  ctaButtons
}) => {
  const filteredSlideshow = slideshow?.filter(isPresent);

  if (filteredSlideshow && filteredSlideshow.length) {
    return (
      <DescriptionTextColumn>
        {content?.leadIn && (
          <DescriptionTextColumnLeadIn>
            {content.leadIn.localized}
          </DescriptionTextColumnLeadIn>
        )}
        {content?.content && (
          <DescriptionTextColumnContent>
            <DescriptionTextColumnContentLeft>
              <TextBox fontSize="medium" content={content.content.localized} />
              {ctaButtons && ctaButtons.length > 0 && (
                <ButtonsContainer
                  align="left"
                  mobileFullSize
                  spacingTop="regular"
                >
                  {ctaButtons.map((b) => (
                    <PageBuilderButtonCTA key={b?._key} {...b} />
                  ))}
                </ButtonsContainer>
              )}
            </DescriptionTextColumnContentLeft>

            <DescriptionTextColumnContentRight>
              <ResponsiveSlideshow items={filteredSlideshow} variant="gray" />
            </DescriptionTextColumnContentRight>
          </DescriptionTextColumnContent>
        )}
      </DescriptionTextColumn>
    );
  } else {
    return (
      <DescriptionText>
        {content?.leadIn && (
          <DescriptionTextLeadIn>
            {content.leadIn.localized}
          </DescriptionTextLeadIn>
        )}
        {(content?.content || (ctaButtons && ctaButtons?.length > 0)) && (
          <DescriptionTextContent>
            {content?.content && (
              <TextBox fontSize="medium" content={content.content.localized} />
            )}
            {ctaButtons && ctaButtons.length > 0 && (
              <ButtonsContainer
                align="left"
                mobileFullSize
                spacingTop="regular"
              >
                {ctaButtons.map((b) => (
                  <PageBuilderButtonCTA key={b?._key} {...b} />
                ))}
              </ButtonsContainer>
            )}
          </DescriptionTextContent>
        )}
      </DescriptionText>
    );
  }
};

export default PageBuilderDescriptionText;

export const fragments = graphql`
  fragment PageBuilderDescriptionText on SanityDescriptionText {
    _key
    content {
      leadIn {
        localized
      }
      content {
        localized
      }
    }
    slideshow {
      ...SlideshowWithVideo
    }

    ctaButtons {
      ...ButtonCTA
    }
  }
`;
